import times from 'lodash/times';

import { MENTION_TYPE_ATTR, MentionTypes } from '@lyearn/lygo-blocks';
import { EditorView } from '@lyearn/lygo-core';

export const getPreviewElements = (rootElement: EditorView['dom']) => {
  const contentElements = document.querySelectorAll(
    `[${MENTION_TYPE_ATTR} = ${MentionTypes.Content}]`,
  );
  const eventElements = document.querySelectorAll(`[${MENTION_TYPE_ATTR} = ${MentionTypes.Event}]`);
  const userElements = document.querySelectorAll(`[${MENTION_TYPE_ATTR} = ${MentionTypes.User}]`);

  const linkElements = rootElement.getElementsByClassName('link-element');
  const urls: string[] = [];

  times(linkElements.length).forEach((_, index) => {
    const link = linkElements[index].getAttribute('href');
    if (link) {
      urls.push(link);
    }
  });

  return { urls, eventElements, contentElements, userElements };
};
